import { render, staticRenderFns } from "./FormPermission.vue?vue&type=template&id=7421fc56&scoped=true&"
import script from "./FormPermission.vue?vue&type=script&lang=js&"
export * from "./FormPermission.vue?vue&type=script&lang=js&"
import style0 from "./FormPermission.vue?vue&type=style&index=0&id=7421fc56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7421fc56",
  null
  
)

export default component.exports